import axios from 'axios';

const myApi = axios.create({
    baseURL: '/api-v2',
  });

export default {
  getRoteiros(lang) {
    return myApi
      .get(lang + '/roteiros')
      .then(response => response.data);
  },
  getRoteiro(lang,idRoteiro) {
    return myApi
      .get(lang+'/roteiros/'+idRoteiro)
      .then(response => response.data);
  },
  getCategorias(lang) {
    return myApi.get(lang + '/roteiros-categorias').then(response => response.data);
  }
};